<template>
  <div>
    <component :is="this.findComponent(userActivity)"
         :userActivity="userActivity"
         :subscription="subscription"
         />
  </div>
</template>

<script>
import BeneficiaryLocationAsk from "@components/user_activities_cards/BeneficiaryLocationAsk.vue";
import BeneficiaryLocationFound from "@components/user_activities_cards/BeneficiaryLocationFound.vue";

export default {
  props: {
    userActivity: Object,
    subscription: Object,
  },
  components: {
    BeneficiaryLocationAsk,
    BeneficiaryLocationFound
},
  methods: {
    findComponent(userActivity){
      const state = userActivity.data.state;

      switch (state) {
        case "initial":
        case "rejected":
        case "rejection_confirmed":
          return BeneficiaryLocationAsk
        case "sent":
        case "confirmed":
          return BeneficiaryLocationFound
      }
    },
  },
};
</script>
